import React, {useContext} from 'react'
import {Button, Col, Form, Popconfirm, Row, Select} from "antd";
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import {toggleBidContentStatus} from "../../../services/serviceOffer";
import config from "../../../config";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const { Option } = Select

const OfferUpdateActions = ({rowIndex, record}) => {
    const {bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent

    const handleDeleteClick = () => {
        setBidList((oldList) => {
            const mock = [...oldList]
            mock.splice(rowIndex, 1)
            return mock
        })
    }

    const selectChanged = (val) => {
        const generateList = replaceIndexAt(
            bidList,
            {
                ...record,
                bidStatus: val
            },
            rowIndex
        )
        toggleBidContentStatus({id: record.id, bidStatus: val} );

        setBidList(generateList)
    }

    return(
        <React.Fragment>
            <Form>
                <Form.Item>
                    <Row>
                        <Col>
                            <Select disabled={!record.id} onChange={selectChanged} style={{minWidth: '125px'}} defaultValue={record.bidStatus}>
                                {
                                    config.bidStatus.map((item, index) => <Option value={item.key} key={`status-${index}`}>{item.text}</Option>)
                                }
                            </Select>
                        </Col>
                        <Col>
                            <Popconfirm
                                title={'Silmek istediğinize emin misiniz ?'}
                                okText={'SİL'}
                                cancelText={'VAZGEÇ'}
                                okButtonProps={{type: 'danger'}}
                                onConfirm={handleDeleteClick}
                            >
                                <Button type={'link'} danger>
                                    Sil
                                </Button>
                            </Popconfirm>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateActions